/*
(C) 2023, 2024 European Space Agency
European Science Operations Centre
Madrid, Spain


System : ESA Datalabs

File Name : sepp_ui/src/index.ts

Author : CGI

Creation Date : 2023-11-16

This file is subject to the terms and conditions defined in 'LICENSE.txt',
which is part of this source code package.
No part of the package, including this file, may be copied, modified, propagated,
or distributed except according to the terms contained in 'LICENSE.txt'.
*/

import { AccessControl, IState, IDLDApiService, ServiceContainer, registerGetServiceContainerCallback, registerNotificationCallback, Notification, DatalabService, BuildService } from "@datalabs/edl_common_ui"
import { State } from './global/state';
import 'ionicons';
import '@datalabs/esa_ui';
import { NotifBalloon } from "./components/notif-balloon/notif-balloon";
import { IRestApiService, AbstractWebSocketService, WebSocketService, DLDApiService, RestApi } from "@datalabs/dld_ui";


const serviceContainer = new ServiceContainer();
registerGetServiceContainerCallback(() => {
    return serviceContainer;
});

const webSocketService: AbstractWebSocketService = new WebSocketService();
serviceContainer.register('WebSocketService', webSocketService);

const dLDApiService: IDLDApiService = new DLDApiService();
serviceContainer.register('IDLDApiService', dLDApiService);

const state: IState = new State()
serviceContainer.register('IState', state);
(window as any).edlState = state;

const datalabService: DatalabService = new DatalabService();
serviceContainer.register('DatalabService', datalabService);

const buildService: BuildService = new BuildService();
serviceContainer.register('BuildService', buildService);

const access: AccessControl = new AccessControl();
serviceContainer.register('AccessControl', access);
(window as any).edlAccess = access;

const restApiService: IRestApiService = new RestApi();
serviceContainer.register('IRestApiService', restApiService);

registerNotificationCallback((notification: Notification) => {
    const component: NotifBalloon = document.querySelector("notif-balloon") as unknown as NotifBalloon
    component.add(notification);
    return component;
});